import { getConnectedRequestProfilePathname } from '../../../utils/link'
import {
  CategoryCell,
  TableBuildingCell,
  TableCellName,
  TableDateCell,
  TableFlatCell,
  TableProviderListCell,
  TableRequestNoCell,
  TableStatusCell,
  TableTitleCell,
  TableUserCell,
  TableUserListCell,
  toPhasesCellValue,
} from '../../Table'
import { toUserMultiValue } from '../../User'
import { IdwellToIdwellRequestTableRowPhases } from '../IdwellToIdwellRequestTableRowPhases'

export function renderCell({
  availableSections,
  context,
  extra,
  isShort,
  item,
  name,
  outboundUuid,
  scrollRef,
  ...restProps
}) {
  const { id, [name]: value, unread } = item

  const cellProps = { ...restProps, unread }

  const linkToRequest = getConnectedRequestProfilePathname({
    availableSections,
    id,
    outboundUuid,
  })

  switch (name) {
    case TableCellName.Assignees:
      return (
        <TableUserListCell
          {...cellProps}
          scrollRef={scrollRef}
          value={value?.map(item => toUserMultiValue(item))}
        />
      )
    case TableCellName.ClosedAt:
    case TableCellName.Created:
    case TableCellName.Updated:
      return <TableDateCell {...cellProps} value={value} />
    case TableCellName.ClosedBy:
    case TableCellName.CreatedBy:
    case TableCellName.Owner:
    case TableCellName.UpdatedBy:
      return (
        <TableUserCell
          {...cellProps}
          value={value ? toUserMultiValue(value) : null}
        />
      )
    case TableCellName.Building:
      return (
        <TableBuildingCell
          {...cellProps}
          context={context}
          scrollRef={scrollRef}
          value={value}
        />
      )
    case TableCellName.Category:
      return <CategoryCell {...cellProps} context={context} value={value} />
    case TableCellName.Flat:
      return <TableFlatCell {...cellProps} value={value} />
    case TableCellName.Phases:
      return (
        <IdwellToIdwellRequestTableRowPhases
          {...cellProps}
          id={id}
          outboundUuid={outboundUuid}
          scrollRef={scrollRef}
          value={toPhasesCellValue(value)}
        />
      )
    case TableCellName.RequestNo:
      return (
        <TableRequestNoCell
          {...cellProps}
          id={id}
          linkTo={linkToRequest}
          value={value}
        />
      )
    case TableCellName.Status:
      return <TableStatusCell {...cellProps} context={context} value={value} />
    case TableCellName.Title:
      return (
        <TableTitleCell
          {...cellProps}
          context={context}
          extra={extra}
          id={id}
          isShort={isShort}
          labels={item.labels}
          tagsProps={{
            directoryId: item.directory_id,
          }}
          value={value}
        />
      )
    case TableCellName.Contractors:
      return (
        <TableProviderListCell
          {...cellProps}
          scrollRef={scrollRef}
          value={value?.map(item => toUserMultiValue(item))}
        />
      )
  }
}
